export default __webpack_public_path__ + "static/media/2_0062.8fbbe671.webp";